document.querySelectorAll(".slider-wrapper").forEach((wrapper) => {

  const track = wrapper.querySelector(".video-track");
  const cards = wrapper.querySelectorAll(".video-card");
  const nextBtn = wrapper.querySelector(".nav-arrow.right");
  const prevBtn = wrapper.querySelector(".nav-arrow.left");
  const dotsContainer = wrapper.querySelector(".slider-dots");

  let index = 0;

  // load videos
  cards.forEach((card) => {
    const video = card.querySelector("video");
    video.src = card.dataset.video;
    video.load();
  });

  // create dots
  cards.forEach((_, i) => {
    const dot = document.createElement("span");
    if (i === 0) dot.classList.add("active");
    dotsContainer.appendChild(dot);
  });

  const dots = dotsContainer.querySelectorAll("span");

  function updateDots() {
    dots.forEach(dot => dot.classList.remove("active"));
    if (dots[index]) dots[index].classList.add("active");
  }
/* ========================= */
/* VIDEO PLAY FUNCTION */
/* ========================= */

let activeVideo = null;

cards.forEach(card => {

  const video = card.querySelector('video');
  const playBtn = card.querySelector('.play-btn');

  card.addEventListener('click', async function () {

    // Pause previous video safely
    if (activeVideo && activeVideo !== video) {
      activeVideo.pause();
      activeVideo.currentTime = 0;
      activeVideo.parentElement.querySelector('.play-btn').style.display = "block";
    }

    if (video.paused) {

      // If video wasn't preloaded yet
      if (!video.src) {
        video.src = card.dataset.video;
        video.load();
      }

      try {
        activeVideo = video;
        video.currentTime = 0.01; // skip heavy first frame
        await video.play();
        playBtn.style.display = "none";
      } catch (err) {
        console.log("Play interrupted");
      }

    } else {
      video.pause();
      playBtn.style.display = "block";
      activeVideo = null;
    }

  });

  video.addEventListener('ended', () => {
    playBtn.style.display = "block";
    activeVideo = null;
  });

});
  function getVisibleCount() {
    return window.innerWidth <= 600 ? 1 : 4;
  }

  function updateSlider() {

    // MOBILE
    if (window.innerWidth <= 600) {
      const cardWidth = cards[0].getBoundingClientRect().width;

      track.scrollTo({
        left: index * cardWidth,
        behavior: "smooth"
      });

      updateDots();
      return;
    }

    // DESKTOP
    const cardWidth = cards[0].offsetWidth + 30;
    track.style.transform = `translateX(-${index * cardWidth}px)`;
    updateDots();
  }

  nextBtn.addEventListener("click", (e) => {
    e.stopPropagation();

    const visibleVideos = getVisibleCount();

    if (index < cards.length - visibleVideos) {
      index++;
    } else {
      index = 0;
    }

    updateSlider();
  });

  prevBtn.addEventListener("click", (e) => {
    e.stopPropagation();

    if (index > 0) {
      index--;
      updateSlider();
    }
  });

  /* MOBILE SCROLL MODE */

  if (window.innerWidth <= 600) {

    track.style.overflowX = "auto";
    track.style.scrollSnapType = "x mandatory";
    track.style.webkitOverflowScrolling = "touch";

    cards.forEach(card => {
      card.style.scrollSnapAlign = "start";
    });

    track.addEventListener("scroll", () => {

      const cardWidth = cards[0].getBoundingClientRect().width;

      index = Math.round(track.scrollLeft / cardWidth);

      updateDots();

    });

  }

});